import { render } from "./EtatCommandesParUtilisateur.vue?vue&type=template&id=2d731aa8&ts=true"
import script from "./EtatCommandesParUtilisateur.vue?vue&type=script&lang=ts"
export * from "./EtatCommandesParUtilisateur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__